<template>
  <div :class="{ 'sirui-search': isQueryPanel, 'edit-form': !isQueryPanel }" ref="sub">
    <el-form
      label-position="right"
      :rules="rules"
      :label-width="labelWidth"
      :model="query"
      ref="queryFrom"
      :validate-on-rule-change="false"
      :disabled="isDisabledForm"
    >
      <el-row :gutter="20">
        <template v-for="(searchColumn, i) in searchColumns">
          <el-row
            :key="i"
            :gutter="10"
            :style="{ display: expand ? 'block' : showRowList.includes(i) ? 'block' : 'none' }"
          >
            <template v-for="(column, index) in searchColumn">
              <el-col
                class="search-item"
                :key="index"
                :span="column.span || colSpan"
                :style="colStyle"
              >
                <!--开始时间-->
                <template v-if="column.type == 'startDaterangePicker'">
                  <el-form-item
                    :label="column.name"
                    :prop="column.prop"
                    :class="{ propClass: column.name.trim().length > propLength }"
                  >
                    <el-date-picker
                      clearable
                      style="width: 100%"
                      v-model="query[column.prop]"
                      :disabled="column.disabled"
                      type="date"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerStartOptions"
                      :editable="column.editable === false ? false : true"
                      @focus="() => handleFocusDate('start', column.prop, column.index)"
                      @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                    ></el-date-picker>
                  </el-form-item>
                </template>
                <!--结束时间-->
                <template v-else-if="column.type == 'endDaterangePicker'">
                  <el-form-item
                    :label="column.name"
                    :prop="column.prop"
                    :class="{ propClass: column.name.trim().length > propLength }"
                  >
                    <el-date-picker
                      clearable
                      style="width: 100%"
                      v-model="query[column.prop]"
                      type="date"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      value-format="yyyy-MM-dd"
                      :disabled="column.disabled"
                      :picker-options="pickerEndOptions"
                      :editable="column.editable === false ? false : true"
                      @focus="() => handleFocusDate('end', column.prop, column.index, column.flag)"
                      @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                    ></el-date-picker>
                  </el-form-item>
                </template>
                <!-- 时分秒 -->
                <!--开始时间-->
                <template v-else-if="column.type == 'startDaterangePickerTime'">
                  <el-form-item
                    :label="column.name"
                    :prop="column.prop"
                    :class="{ propClass: column.name.trim().length > propLength }"
                  >
                    <el-date-picker
                      clearable
                      style="width: 100%"
                      v-model="query[column.prop]"
                      :disabled="column.disabled"
                      type="datetime"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="pickerStartOptions"
                      @focus="() => handleFocusDate('start', column.prop, column.index)"
                      @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                    ></el-date-picker>
                  </el-form-item>
                </template>
                <!--结束时间-->
                <template v-else-if="column.type == 'endDaterangePickerTime'">
                  <el-form-item
                    :label="column.name"
                    :prop="column.prop"
                    :class="{ propClass: column.name.trim().length > propLength }"
                  >
                    <el-date-picker
                      clearable
                      style="width: 100%"
                      v-model="query[column.prop]"
                      type="datetime"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="pickerEndOptions"
                      @focus="() => handleFocusDate('end', column.prop, column.index)"
                      @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                    ></el-date-picker>
                  </el-form-item>
                </template>
                <!--文案-->
                <p class="line-text" v-else-if="column.type == 'text'">{{ column.text }}</p>
                <!-- 金额 -->
                <template v-else-if="column.type == 'inputAmount'">
                  <el-row>
                    <el-form-item
                      :prop="column.prop"
                      :label="column.name"
                      :class="{ propClass: column.name.trim().length > propLength }"
                    >
                      <el-tooltip
                        :disabled="!query[column.prop]"
                        class="item"
                        effect="dark"
                        :content="String(query[column.prop])"
                        placement="top"
                      >
                        <input-number
                          style="width: 100%"
                          :max="column.max"
                          :min="column.min"
                          v-model="query[column.prop]"
                          :precision="
                            column.precision || column.precision === 0 ? column.precision : 2
                          "
                          :clearable="true"
                          :disabled="column.disabled || false"
                          @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                        ></input-number>
                      </el-tooltip>
                    </el-form-item>
                  </el-row>
                </template>
                <!--输入范围-->
                <template v-else-if="column.type == 'inputRange'">
                  <el-row>
                    <el-col
                      :span="
                        column.span == '12'
                          ? 12 - Number(Boolean(column.unit))
                          : 16 - Number(Boolean(column.unit))
                      "
                    >
                      <el-form-item
                        :prop="column.prop[0]"
                        :label="column.name"
                        :class="{ propClass: column.name.trim().length > propLength }"
                      >
                        <el-tooltip
                          :disabled="!query[column.prop[0]]"
                          class="item"
                          effect="dark"
                          :content="String(query[column.prop[0]])"
                          placement="top"
                        >
                          <input-number
                            style="width: 100%"
                            :max="column.max"
                            :min="column.min"
                            v-model="query[column.prop[0]]"
                            :precision="
                              column.precision || column.precision === 0 ? column.precision : 2
                            "
                            :clearable="true"
                          ></input-number>
                        </el-tooltip>
                      </el-form-item>
                    </el-col>
                    <el-col :span="1" style="text-align: center; line-height: 32px">-</el-col>
                    <el-col
                      :span="
                        column.span == '12'
                          ? 11 - Number(Boolean(column.unit))
                          : 7 - Number(Boolean(column.unit))
                      "
                    >
                      <el-form-item label-width="0px" :prop="column.prop[1]">
                        <el-tooltip
                          :disabled="!query[column.prop[1]]"
                          class="item"
                          effect="dark"
                          :content="String(query[column.prop[1]])"
                          placement="top"
                        >
                          <input-number
                            style="width: 100%"
                            :max="column.max"
                            :min="column.min"
                            v-model="query[column.prop[1]]"
                            :precision="
                              column.precision || column.precision === 0 ? column.precision : 2
                            "
                            :clearable="true"
                          ></input-number>
                        </el-tooltip>
                      </el-form-item>
                    </el-col>
                    <el-col
                      v-if="column.unit"
                      :span="2"
                      style="text-align: center; line-height: 32px; font-size: 12px; color: #666"
                      >{{ column.unit }}
                    </el-col>
                  </el-row>
                </template>
                <!-- 取值范围和输入框组合 -->
                <select-range
                  v-else-if="column.type == 'selectRange'"
                  :max="column.max"
                  :prop="column.prop"
                  :name="column.name"
                  :clearabled="column.clearabled || true"
                  :value="[query[column.prop[0]], query[column.prop[1]]]"
                  :placeholder="column.placeholder || getPlaceHolder(column)"
                  @input="(val) => handleQueryChange(val, column)"
                ></select-range>
                <!--选择框和输入框组合-->
                <template v-else-if="column.type == 'selectInput'">
                  <el-form-item
                    :label="column.name"
                    :class="{ propClass: column.name.trim().length > propLength }"
                  >
                    <select-input
                      :options="column.options"
                      :inputType="column.inputType"
                      :prop="column.prop"
                      :value="[query[column.prop[0]], query[column.prop[1]]]"
                      @input="(val) => handleQueryChange(val, column)"
                      clearable
                    ></select-input>
                  </el-form-item>
                </template>
                <template v-else-if="column.type == 'selectDouble'">
                  <el-form-item
                    :label="column.name"
                    :class="{ propClass: column.name.trim().length > propLength }"
                  >
                    <select-double
                      :options1="column.options1"
                      :options2="column.options2"
                      :prop="column.prop"
                      :value="[query[column.prop[0]], query[column.prop[1]]]"
                      :isMultiple="column.isMultiple || [false, false]"
                      @input="(val) => handleQueryChange(val, column)"
                      @change="(prop, val) => handleChange(val, prop, column.changeMethod)"
                      clearable
                    ></select-double>
                  </el-form-item>
                </template>

                <!--radio-->
                <template v-else-if="column.type == 'checkbox'">
                  <template v-if="column.labelPosition == 'right'">
                    <el-form-item label-width="90px" :prop="column.prop">
                      <el-checkbox
                        v-model="query[column.prop]"
                        :true-label="column.trueLable"
                        :false-label="column.falseLable"
                        :disabled="column.disabled || false"
                        @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                        >{{ column.name }}
                      </el-checkbox>
                      <el-button
                        style="margin-left: 20px; height: 30px"
                        type="primary"
                        v-if="column.moreBtn || false"
                        @click="changeMethod(column.key, '', column.changeMethod)"
                        >{{ $t('salePurchase.search.credit') }}</el-button
                      >
                    </el-form-item>
                  </template>
                  <el-form-item v-else :prop="column.prop" :label="column.name">
                    <el-checkbox
                      :checked="column.isChecked ? column.isChecked : false"
                      v-model="query[column.prop]"
                      :true-label="column.trueLable"
                      :false-label="column.falseLable"
                      @change="(val) => changeChecked(column.prop, val)"
                      :disabled="column.disabled"
                      >{{ column.label }}</el-checkbox
                    >
                  </el-form-item>
                </template>
                <template v-else-if="column.type == 'textarea'">
                  <el-form-item :prop="column.prop" :label="column.name">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      :maxlength="column.maxlength || 32"
                      v-model="query[column.prop]"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      clearable
                      :disabled="column.disabled || false"
                    />
                  </el-form-item>
                </template>
                <el-form-item
                  v-else
                  :label="column.name"
                  :class="{ propClass: column.name.trim().length > propLength }"
                  :prop="column.prop"
                >
                  <el-tooltip
                    v-if="column.type == 'input'"
                    :disabled="!query[column.prop]"
                    class="item"
                    effect="dark"
                    :content="
                      Array.isArray(query[column.prop])
                        ? query[column.prop].join(',')
                        : query[column.prop]
                    "
                    placement="top"
                  >
                    <!--输入框-->
                    <el-input
                      style="width: 100%"
                      v-if="column.type == 'input'"
                      :maxlength="column.maxlength || 32"
                      v-model="query[column.prop]"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      clearable
                      @blur="
                        (val) => {
                          changeMethod(val, column.relatedColumn, column.changeMethod, column.prop);
                        }
                      "
                      :disabled="column.disabled || false"
                    >
                      <template slot="append" v-if="column.append">{{ column.append }}</template>
                    </el-input>
                  </el-tooltip>
                  <!-- 带图标的输入框 -->
                  <el-tooltip
                    v-if="column.type == 'inputIcon'"
                    :disabled="!query[column.prop]"
                    class="item"
                    effect="dark"
                    :content="
                      Array.isArray(query[column.prop])
                        ? query[column.prop].join(',')
                        : query[column.prop]
                    "
                    placement="top"
                  >
                    <el-input
                      style="width: 100%"
                      v-if="column.type == 'inputIcon'"
                      :maxlength="column.maxlength || 32"
                      v-model="query[column.prop]"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      clearable
                      :disabled="column.disabled || false"
                      suffix-icon="el-icon-search"
                    ></el-input>
                  </el-tooltip>
                  <!-- 数字输入框 -->
                  <el-tooltip
                    :disabled="!query[column.prop]"
                    class="item"
                    effect="dark"
                    :content="
                      Array.isArray(query[column.prop])
                        ? query[column.prop].join(',')
                        : query[column.prop]
                    "
                    placement="top"
                  >
                    <el-input
                      v-if="column.type == 'inputNumber'"
                      clearable
                      style="width: 100%"
                      v-model="query[column.prop]"
                      :maxlength="column.maxlength || 20"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      :disabled="column.disabled || false"
                      @input="
                        (val) =>
                          limitAmount(
                            val,
                            column.max,
                            column.prop,
                            column.changeMethod,
                            column.precision
                          )
                      "
                    >
                      <template v-if="column.append" slot="append">{{ column.append }}</template>
                    </el-input>
                  </el-tooltip>

                  <!--单选框-->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="top"
                    v-if="column.type == 'select'"
                    :disabled="!query[column.prop]"
                    :content="
                      query[column.prop] && !column.multiple && column.options[0]
                        ? column.options.find(
                            (item) => item[column.value || 'value'] === query[column.prop]
                          )?.[column.label ? column.label : 'label']
                        : ''
                    "
                  >
                    <el-select
                      style="width: 100%"
                      v-if="column.type == 'select'"
                      v-model="query[column.prop]"
                      :multiple="column.multiple"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      @change="
                        (val) => {
                          changeMethod(val, column.relatedColumn, column.changeMethod, column.prop);
                        }
                      "
                      @clear="
                        (val) => {
                          clearMethod(val, column.clearMethod);
                        }
                      "
                      :filterable="column.filterable === false ? false : true"
                      :clearable="column.clearable === false ? false : true"
                      :disabled="column.disabled || false"
                    >
                      <el-option
                        v-for="(item, index) in column.options"
                        :key="index"
                        :label="item[column.label ? column.label : 'label']"
                        :value="item[column.value ? column.value : 'value']"
                      ></el-option>
                    </el-select>
                  </el-tooltip>

                  <!--获取后端数据渲染的下拉框-->
                  <ajax-select
                    style="width: 100%"
                    v-if="column.type == 'ajaxSelect' || column.type == 'dictSelect'"
                    :type="column.type"
                    v-model="query[column.prop]"
                    :placeholder="column.placeholder || getPlaceHolder(column)"
                    :apiUrl="column.apiUrl"
                    :apiData="column.apiData"
                    :multiple="column.multiple || false"
                    :clearable="column.clearable === false ? false : true"
                    :filterable="column.filterable || false"
                    :dataString="column.dataString"
                    :valueKey="column.valueKey"
                    :labelKey="column.labelKey"
                    :method="column.method"
                    :disabled="column.disabled"
                    :valueType="column.valueType || 'string'"
                    @input="
                      (val) => {
                        changeMethod(val, column.relatedColumn, column.changeMethod, column.prop);
                      }
                    "
                  ></ajax-select>
                  <!--多选框-->
                  <el-select
                    style="width: 100%"
                    v-if="column.type == 'selectMultiple'"
                    multiple
                    clearable
                    filterable
                    v-model="query[column.prop]"
                    :placeholder="column.placeholder || getPlaceHolder(column)"
                  >
                    <el-option
                      v-for="item in column.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <!--下拉树-->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="top"
                    v-if="column.type == 'treeSelect'"
                    :content="
                      Array.isArray(column.tipMessage)
                        ? column.tipMessage.join(',')
                        : column.tipMessage
                    "
                  >
                    <tree-select
                      style="width: 100%"
                      :ref="column.ref || 'treeSelect'"
                      :disabled="!!column.disabled"
                      :model="column.prop"
                      :apiUrl="column.apiUrl"
                      :apiData="column.apiData"
                      :clearable="column.clearable || true"
                      :isName="column.isName"
                      :isLine="column.isLine"
                      :flat="column.flat"
                      :isSpace="column.isSpace"
                      :multiple="column.multiple"
                      :returnType="column.returnType || ''"
                      :currentValue="column.currentValue || null"
                      :trigger="column.trigger"
                      :filterData="column.filterData || ((data) => data)"
                      @setSearchModal="setSearchModal"
                      :normalizerFlag="column.normalizerFlag"
                      :disableBranchNodes="column.disableBranchNodes"
                      :defaultExpandLevel="column.defaultExpandLevel"
                      @input="
                        (val) => {
                          changeMethod(val, column.relatedColumn, column.changeMethod, column.prop);
                        }
                      "
                    ></tree-select>
                  </el-tooltip>
                  <!--日期-->
                  <template v-if="column.forecastYear || column.forecastMonth">
                    <el-date-picker
                      clearable
                      style="width: 100%"
                      v-if="
                        column.type == 'date' || column.type == 'month' || column.type == 'year'
                      "
                      v-model="query[column.prop]"
                      :type="column.type"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      :value-format="column.format || 'yyyy-MM-dd'"
                      :disabled="column.disabled"
                      :default-value="
                        column.forecastYear == null ||
                        column.forecastMonth == null ||
                        column.forecastYear == '' ||
                        column.forecastMonth == ''
                          ? new Date()
                          : new Date(column.forecastYear + '-' + column.forecastMonth)
                      "
                      :picker-options="pickerTimeOptions"
                      @focus="
                        () => handleFocusDateFin('date', column.forecastYear, column.forecastMonth)
                      "
                    ></el-date-picker>
                  </template>
                  <template v-else>
                    <template v-if="column.icon">
                      <el-row :gutter="0">
                        <el-col :span="20">
                          <el-date-picker
                            clearable
                            style="width: 100%"
                            v-if="
                              column.type == 'date' ||
                              column.type == 'month' ||
                              column.type == 'year'
                            "
                            v-model="query[column.prop]"
                            :type="column.type"
                            :placeholder="column.placeholder || getPlaceHolder(column)"
                            :value-format="column.format || 'yyyy-MM-dd'"
                            :format="column.format || 'yyyy-MM-dd'"
                            :picker-options="
                              column.endDate ? pickerDateTimeOptions : column.pickerSettleOptions
                            "
                            :disabled="column.disabled"
                          ></el-date-picker>
                        </el-col>
                        <el-col :span="4">
                          <i
                            :class="column.icon"
                            style="margin-left: 10px; width: 20px; height: 20px; cursor: pointer"
                            @click="() => iconHandler(column, column.iconMethod)"
                          ></i>
                        </el-col>
                      </el-row>
                    </template>
                    <template v-else>
                      <el-date-picker
                        clearable
                        style="width: 100%"
                        v-if="
                          column.type == 'date' || column.type == 'month' || column.type == 'year'
                        "
                        v-model="query[column.prop]"
                        :type="column.type"
                        :placeholder="column.placeholder || getPlaceHolder(column)"
                        :value-format="column.format || 'yyyy-MM-dd'"
                        :format="column.format || 'yyyy-MM-dd'"
                        :editable="column.editable === false ? false : true"
                        :picker-options="
                          column.endDate ? pickerDateTimeOptions : column.pickerSettleOptions
                        "
                        :disabled="column.disabled"
                        @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                      ></el-date-picker>
                    </template>
                  </template>
                  <!--日期时间-->
                  <el-date-picker
                    clearable
                    style="width: 100%"
                    v-if="column.type == 'datetime'"
                    v-model="query[column.prop]"
                    type="datetime"
                    :placeholder="column.placeholder || getPlaceHolder(column)"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerTimeOptions"
                    :disabled="column.disabled"
                  ></el-date-picker>
                  <!--日期范围-->
                  <el-date-picker
                    clearable
                    style="width: 100%"
                    v-if="column.type == 'daterange'"
                    v-model="query[column.prop]"
                    :disabled="column.disabled"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    :range-separator="$t('search.to')"
                    :start-placeholder="$t('search.start')"
                    :end-placeholder="$t('search.end')"
                  ></el-date-picker>
                  <!--日期月份范围-->
                  <el-date-picker
                    clearable
                    style="width: 100%"
                    v-if="column.type == 'monthrange'"
                    v-model="query[column.prop]"
                    :disabled="column.disabled"
                    type="monthrange"
                    :value-format="column.format || 'yyyy-MM'"
                    :format="column.format || 'yyyy-MM'"
                    :range-separator="$t('search.to')"
                    :start-placeholder="$t('search.start')"
                    :end-placeholder="$t('search.end')"
                  ></el-date-picker>
                  <!--下拉table选择-->
                  <SearchModal
                    ref="searchModal"
                    class="searchTable"
                    v-if="column.type == 'searchTable'"
                    :model="column.prop"
                    :placeholder="column.placeholder || getPlaceHolder(column)"
                    :width="column.width"
                    :API="column.API"
                    :propCode="column.propCode"
                    :propName="column.propName"
                    :query="column.query"
                    :page="column.page"
                    :dbclone="column.dbclone"
                    :isMultiple="column.isMultiple"
                    :parseExtendMap="parseExtendMap"
                    :currentValue="column.currentValue"
                    :checkRowKeys="column.checkRowKeys"
                    :searchColumns="column.searchColumns"
                    :columnList="column.columnList"
                    :buttonList="column.buttonList"
                    :isFixed="column.isFixed"
                    @setSearchModal="setSearchModal"
                    @chooseClick="chooseClick"
                    :trigger="column.trigger"
                    @dblclickEvent="dblclickEvent"
                  ></SearchModal>
                  <!-- 弹窗搜索：具体的 -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="top"
                    v-if="column.type == 'searchTableSpec'"
                    :content="column.currentValue"
                  >
                    <search-table
                      :ref="column.ref || 'searchTable'"
                      v-model="query[column.prop]"
                      :placeholder="column.placeholder || getPlaceHolder(column)"
                      @input="
                        (val) => {
                          changeMethod(val, column.relatedColumn, column.changeMethod, column.prop);
                        }
                      "
                      :searchType="column.searchType"
                      :extraData="column.extraData"
                      :disabled="column.disabled || isDisabledForm"
                      :checkRowKeys="column.checkRowKeys"
                      :currentValue="column.currentValue"
                      :isMultiple="column.isMultiple"
                      :defaultQuery="column.defaultQuery || {}"
                      :isNeedMultipleValue="column.isNeedMultipleValue"
                    ></search-table>
                  </el-tooltip>
                  <el-select
                    style="width: 100%"
                    v-if="column.type == 'dict'"
                    v-model="query[column.prop]"
                    :placeholder="column.placeholder || getPlaceHolder(column)"
                    @change="
                      (val) => {
                        changeMethod(val, column.relatedColumn, column.changeMethod, column.prop);
                      }
                    "
                    @clear="
                      (val) => {
                        clearMethod(val, column.clearMethod);
                      }
                    "
                    filterable
                    :collapse-tags="column.collapseTags || false"
                    :multiple="column.multiple || false"
                    :clearable="column.clearabled || true"
                    :disabled="column.disabled || false"
                  >
                    <el-option
                      v-for="item in dictListMap[column.dictType]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <!-- 模糊查询框 -->
                  <el-autocomplete
                    v-if="column.type == 'inputAuto'"
                    class="inline-input"
                    v-model="query[column.prop]"
                    :fetch-suggestions="column.querySearch"
                    :placeholder="column.placeholder || getPlaceHolder(column)"
                    :trigger-on-focus="column.triggerOn || true"
                  ></el-autocomplete>
                  <i v-if="column.showTag" class="dotClass"></i>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </template>
        <el-row
          v-if="isQueryPanel"
          style="display: flex; justify-content: flex-end; margin-bottom: 10px"
        >
          <!-- <el-col class="text-right" :span="buttonCol"> -->
          <el-col class="text-right" :span="6">
            <a href="javascript:;" class="search" @click="search()">
              <img src="../../assets/tableImg/search.svg" alt="" />{{ $t('search.search') }}</a
            >
            <a href="javascript:;" class="reset" @click="resetForm('queryFrom')">
              <img src="../../assets/tableImg/reset.svg" alt="" />{{ $t('search.reset') }}</a
            >
            <div
              :class="{ 'open-btn': true, active: !expand }"
              v-if="columns.length > columnNumber"
              @click="toggle"
            >
              <img src="../../assets/tableImg/open-btn.svg" alt="" />
            </div>
          </el-col>
        </el-row>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  import ajaxSelect from '@/components/form-item/ajax-select';
  import treeSelect from '@/components/form-item/tree-select';
  import searchTable from '@/components/form-item/search-table';
  import selectDouble from '@/components/form-item/select-double';
  import selectInput from '@/components/form-item/selectInput';
  import selectRange from '@/components/form-item/select-range';
  import inputNumber from '@/components/form-item/input-number';
  import { toFormErrorTop } from '@/common/js/util';

  export default {
    components: {
      SearchModal,
      ajaxSelect,
      treeSelect,
      searchTable, // 弹窗搜索：包括 商品、人员等，可新增
      selectInput,
      inputNumber,
      selectRange, // 大于小于、输入框
      selectDouble,
    },
    data() {
      return {
        // labelWidth: '120px',
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          },
        },
        pickerDateTimeOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          },
        },
        pickerStartOptions: {}, // 开始日期配置
        pickerEndOptions: {}, // 结束日期配置
        pickerTimeOptions: {},
        expand: this.isQueryPanel ? false : true,
      };
    },
    props: {
      query: {
        type: Object,
        default: () => {},
      },
      labelWidth: {
        type: String,
        default: '120px',
      },
      //解析extendMap
      parseExtendMap: {
        type: Boolean,
        default: false,
      },
      /**
       * columns筛选参数：
       * name:'名称'
       * prop:'字段名字'
       * type'编辑类型',['inpput','select','selectMultiple','date','datetime']
       * options:当编辑类型是select时的初始数据。
       * maxlength:可输入的最大长度
       */
      columns: {
        type: Array,
        default: () => [],
      },
      // 搜索默认分隔的colSpan，默认分成4列
      colSpan: {
        type: Number,
        default: 6,
      },
      // 右边按钮占位，弹窗占位需要宽一点
      buttonSpan: {
        type: Number,
        default: 4,
      },
      rules: {
        type: Object,
        default: () => {},
      },
      // 是否为搜索面板
      isQueryPanel: {
        type: Boolean,
        default: true,
      },
      // 是否禁用表单
      isDisabledForm: {
        type: Boolean,
        default: false,
      },
      // 行样式
      colStyle: {
        type: Object,
        default: () => {},
      },
      // 默认显示几行
      defaultRow: {
        type: Number,
        default: 1,
      },
    },
    computed: {
      //字典数据
      ...mapState({
        dictListMap: (state) => state.dict.dictListMap,
      }),
      // 表单列数
      columnNumber() {
        const colSpan = this.colSpan;
        return Math.floor(24 / colSpan);
      },
      expandText() {
        return !this.expand ? this.$t('search.spread') : this.$t('search.packUp');
      },
      inputTip() {
        return this.$t('search.input');
      },
      selectTip() {
        return this.$t('search.choose');
      },
      showRowList() {
        let result = [];
        for (let i = 0; i < this.defaultRow; i++) {
          result.push(i);
        }
        return result;
      },
      searchColumns() {
        let list = [];
        let all = 0;
        // 根据每一列占据的span数组装二维数组
        const colSpan = this.colSpan;
        let children = [];
        for (let i = 0; i < this.columns.length; i++) {
          let item = this.columns[i];
          if (item.isHidden) {
            continue;
          }

          item.index = i;
          const span = item.span || colSpan;
          if (all + span < 24) {
            all += span;
            children.push(item);
          } else if (all + span === 24) {
            list.push(children.concat(item));
            all = 0;
            children = [];
          } else {
            list.push(children);
            children = [item];
            all = span;
          }
        }
        // this.columns.forEach((item, index) => {

        // });
        if (children.length) {
          list.push(children);
        }
        return list;
      },
      propLength() {
        return this.$store.getters.language == 'zh_CN' ? 8 : 14;
      },
      buttonCol() {
        if (!this.isQueryPanel) {
          return 0;
        } else {
          const span = this.buttonSpan;
          return this.$store.getters.language == 'zh_CN' ? span : span + 1;
        }
      },
    },
    methods: {
      // 效验参数，提交使用
      validate(fn) {
        this.$refs.queryFrom.validate((valid) => fn(valid, valid ? this.query : {}));
      },
      clearValidate(val) {
        this.$refs.queryFrom.clearValidate(val);
      },
      // 校验数据
      getValidateFormData(isValidate = true) {
        return new Promise((resolve, reject) => {
          if (isValidate) {
            this.$refs.queryFrom.validate((valid) => {
              if (valid) {
                resolve(this.query);
              } else {
                this.$message.error('请填写完资料');
                toFormErrorTop();
                reject({});
              }
            });
          } else {
            resolve(this.query);
          }
        });
      },
      handleChange(val, prop, method) {
        if (method) {
          this.$emit(method, { val: val, prop: prop });
        }
      },
      iconHandler(column, method) {
        if (method) {
          this.$emit(method, column);
        }
      },
      //number限制长度和位数
      limitAmount(value, max, prop, method, precision) {
        console.log('limitAmount', value, max, prop, method, precision);
        if (!value) this.query[`${prop}Local`] = '';
        value = value.toString().replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
        value = value.toString().replace(/^\./g, ''); //验证第一个字符是数字
        value = value.toString().replace(/\.{2,}/g, '.'); //只保留第一个, 清除多余的
        value = value.toString().replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');

        console.log('cleanedValue', value);
        if (precision == 1) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'); //只能输入一位小数
        } else if (precision == 2) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两位小数
        } else if (precision == 3) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入四位小数
        } else if (precision == 4) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3'); //只能输入四位小数
        } else if (precision == 5) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入五位小数
        } else if (precision == 6) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入六位小数
        } else if (precision == 7) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入6位小数
        } else if (precision == 8) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入8位小数
        } else {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入6位小数
        }
        console.log('precisionedValue', value);
        if (Number(value) >= Number(max)) {
          value = max;
        }

        this.query[prop] = value;
        if (!method) {
          return;
        }

        this.$emit(method, { prop: prop, val: value });
      },
      getPlaceHolder(option) {
        // 已禁用的选项不展示 placeholder
        if (option.disabled) {
          return '';
        }
        const inputArr = ['input', 'textarea', 'inputNumber'];
        return (
          (inputArr.indexOf(option.type) > -1 ? this.inputTip : this.selectTip) +
          (option.name === '至' ? '日期' : option.name || '')
        );
      },
      // 资金预报表根据选择的年月限制选择的日期范围
      handleFocusDateFin(type, forecastYear, forecastMonth) {
        if (type == 'date') {
          let timeStart = forecastYear + '/' + forecastMonth + '/01'; //解决火狐和谷歌时区不一致问题
          let timeEnd = new Date(timeStart);
          timeEnd.setMonth(timeEnd.getMonth() + 1);
          this.pickerTimeOptions = {
            disabledDate: (time) => {
              return (
                time.getTime() < new Date(timeStart).getTime() ||
                time.getTime() > new Date(timeEnd).getTime() - 24 * 60 * 60 * 1000
              );
            },
          };
        }
      },
      // 开始结束日期
      handleFocusDate(type, prop, index, flag) {
        const dateProp =
          type == 'start' ? this.columns[index + 1].prop : this.columns[index - 1].prop;
        const pickerOptions = {
          disabledDate: (time) => {
            return this.disabledDate(time, dateProp, type, flag);
          },
        };
        if (type == 'start') {
          this.pickerStartOptions = pickerOptions;
        } else {
          this.pickerEndOptions = pickerOptions;
        }
      },
      // 开始结束日期禁用日期
      disabledDate(time, prop, type, flag) {
        if (type === 'end') {
          let startDate = this.query[prop];
          if (flag == '1') {
            if (startDate) {
              return (
                time.getTime() < new Date(startDate).getTime() - 24 * 60 * 60 * 1000 ||
                time.getTime() > Date.now()
              );
            } else {
              return time.getTime() > Date.now();
            }
          }
          if (startDate) {
            return time.getTime() < new Date(startDate).getTime() - 24 * 60 * 60 * 1000;
          }
        } else {
          let endDate = this.query[prop];
          if (endDate) {
            return time.getTime() > new Date(endDate).getTime();
          }
        }
      },
      setItem(item, val) {
        this.query[item] = val;
      },
      resetForm(from) {
        if (this.$refs.searchModal) {
          this.$refs.searchModal[0].resetClick();
        }
        if (this.$refs.treeSelect) {
          this.$refs.treeSelect[0].resetClick();
        }
        if (this.$refs.searchTable) {
          this.$refs.searchTable.forEach((item) => {
            item && item.resetClick();
          });
        }
        this.$refs[from].resetFields();
        this.$emit('resetBtnClick');
      },
      search() {
        for (let item of this.columns) {
          if (
            item.type === 'inputRange' &&
            this.query[item.prop[0]] &&
            this.query[item.prop[1]] &&
            Number(this.query[item.prop[0]]) > Number(this.query[item.prop[1]])
          ) {
            return this.$message({
              showClose: true,
              message: this.$t(`${item.name}输入值下限不能大于上限`),
              type: 'error',
            });
          }
          if (item.type === 'inputRange') {
            // 暂时先全部统一，若需要配置可再加属性 sxp 20210120 update
            if (!this.query[item.prop[0]] && !this.query[item.prop[1]]) {
              this.query[item.prop[0]] = this.query[item.prop[1]] = null;
            } else {
              this.query[item.prop[0]] = this.query[item.prop[0]] ? this.query[item.prop[0]] : 0;
              this.query[item.prop[1]] = this.query[item.prop[1]] ? this.query[item.prop[1]] : null;
            }
          }
        }
        this.$emit('searchBtnClick', { query: this.query });
      },
      setSearchModal(model, row) {
        this.query[model] = row;
      },
      handleQueryChange(val, column) {
        if (
          column.type == 'selectInput' ||
          column.type == 'selectRange' ||
          column.type == 'selectDouble'
        ) {
          this.query[column.prop[0]] = val[0];
          this.query[column.prop[1]] = val[1];
        }
        // 处理其他变化
      },
      changeMethod(val, relatedColumn, method, prop) {
        if (!method) {
          return;
        }
        if (relatedColumn) {
          this.query[relatedColumn] = null;
        }
        if (typeof method === 'function') {
          method(val);
        } else {
          this.$emit(method, { val: val, prop });
        }
      },
      clearMethod(val, method) {
        if (!method) {
          return;
        }
        this.$emit(method, { val: val });
      },
      toggle() {
        this.expand = !this.expand;
      },
      changeChecked(prop, val) {
        this.$set(this.query, prop, val);
        this.$emit('changeChecked', prop, val);
      },
      //点击按钮调用父页面方法
      chooseClick(buttonUrl, arr) {
        this.$emit('chooseClick', buttonUrl, arr);
      },
      //双击事件
      dblclickEvent(value) {
        this.$emit('dblclickEvent', value);
      },
      //刷新表格
      uploadData() {
        if (this.$refs.searchModal) {
          this.$refs.searchModal[0].searchBtnClick();
        }
      },
      //返回列表数据
      returnTableData() {
        return this.$refs.searchModal[0].returnTableData();
      },
      returnTableDatas() {
        this.$refs.searchModal[0].resetFlag = false;
      },
      // 模糊查询
      querySearch(queryString, cb) {
        var qdata = this.selectData;
        var results = queryString ? qdata.filter(this.createFilter(queryString)) : qdata;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (selectData) => {
          return selectData.value.toLowerCase().indexOf(queryString.toLowerCase()) > 0;
        };
      },
    },
    mounted() {
      console.log(this.rules, '1111');
      // this.$refs.queryFrom.resetFields();
    },
  };
</script>
<style lang="scss">
  .popper__arrow::after {
    border-bottom-color: #000000 !important;
  }

  .el-popper-search {
    .popper__arrow::after {
      border-bottom-color: #ffffff !important;
    }
  }
</style>
<style lang="scss" scoped>
  $maintheme: #6299fe;

  .sirui-search {
    box-shadow: 0px 1px 5px #ddd;
  }
  ::v-deep .el-form-item__label {
    font-size: 13px;
  }
  .sirui-search .el-form-item {
    margin-bottom: 13px;
  }

  .search-expand {
    cursor: pointer;
    margin: 0 0 0 1px;
    font-size: 12px;
    color: $maintheme;
  }

  .edit-form {
    background: #fff;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .sirui-search {
    background: #fff;
    border-radius: 4px;
    padding: 20px 20px 20px 30px;
    padding-bottom: 3px;
  }

  @media screen and (max-width: 1536px) {
    .text-right {
      .search {
        width: 65px;
      }

      .reset {
        width: 65px;
      }
    }
  }

  .text-right {
    a {
      display: inline-block;
      width: 90px;
      height: 30px;
      line-height: 30px;
      border-radius: 3px;
      margin-right: 10px;
      text-align: center;
      font-size: 12px;
    }

    img {
      vertical-align: middle;
      padding-right: 6px;
    }

    .search {
      background-color: #409eff;
      color: #ffffff;
    }

    .reset {
      border: 1px solid #e4e6eb;
      color: #409eff;
    }

    .open-btn {
      width: 30px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #e4e6eb;
      display: inline-block;
      cursor: pointer;
      color: #00b400;
      text-align: center;
      border-radius: 3px;

      img {
        padding-right: 0;
      }
    }

    .active {
      transform: rotate(180deg);
    }
  }

  .el-button {
    border-radius: 3px;
    border: 1px solid #6299fe;
    color: #6299fe;
    margin-left: 3px;
  }

  .el-button--primary {
    background-color: $maintheme;
    border-color: $maintheme;
    color: #fff;
  }

  .line-text {
    font-size: 14px;
    color: #888;
    margin-bottom: 15px;
  }

  ::v-deep .el-select__caret {
    transform: rotateZ(0) !important;
  }

  ::v-deep .el-select__caret.is-reverse {
    transform: rotateZ(180deg) !important;
  }

  ::v-deep .el-icon-arrow-up {
    width: 25px;
    background: url('../../assets/serach/select.svg') center center no-repeat;
    background-size: 20px;
  }

  ::v-deep .el-icon-arrow-up:before {
    content: '替';
    font-size: 16px;
    visibility: hidden;
  }

  ::v-deep .el-icon-arrow-down {
    width: 25px;
    background: url('../../assets/serach/select.svg') center center no-repeat;
    background-size: 20px;
    //transform: rotateZ(180deg);
  }
  .dotClass {
    background-color: yellow;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 10px;
    right: -15px;
  }
</style>
